import { Component, Input, OnInit } from "@angular/core"
import { PopoverController } from "@ionic/angular"
import { Subject, takeUntil } from "rxjs"
import { Course } from "src/app/models/course"
import { Lesson } from "src/app/models/lesson"
import { LessonSong } from "src/app/models/lesson-song"
import { Song } from "src/app/models/song"
import { Teacher } from "src/app/models/teacher"
import { TeacherProvider } from "src/app/providers/teacher/teacher.provider"
import { StaticDataService } from "src/app/services/static-data.service"
import { TeacherStore } from "src/app/stores/teacher.store"

@Component({
  selector: "app-bowling-activity-manage-popover",
  templateUrl: "./bowling-activity-manage-popover.component.html",
  styleUrls: ["./bowling-activity-manage-popover.component.scss"],
})
export class BowlingActivityManagePopoverComponent implements OnInit {

  ngUnsubscribeTeacher = new Subject();
  
  selectedActivity: LessonSong | null
  @Input() lesson: Lesson
  @Input() course: Course

  @Input() song: Song

  teacher: Teacher = Teacher.defaults()

  waiting: boolean = false
  hasValue: boolean = false
  
  constructor(
    private staticDataService: StaticDataService,
    private popoverCtrl: PopoverController,
    private teacherProvider: TeacherProvider,
    private teacherStore: TeacherStore,
  ) {
    
  }
  
  
  ngOnInit(): void {
    this.selectedActivity = null

    this.teacher = this.teacherProvider.teacher
    this.teacherStore.state$
      .pipe(takeUntil(this.ngUnsubscribeTeacher))
      .subscribe(() => {
        this.teacher = this.teacherProvider.teacher
      });
  }

  changed(event) {

    if (this.selectedActivity) {
      this.hasValue = true
      return
    }

    setTimeout(() => {
      this.changed(event)
    }, 250)
  }

  cancel() {
    this.popoverCtrl.dismiss()
    this.hasValue = false
    this.selectedActivity = null
  }

  submit() {

    if (this.selectedActivity) {
      this.waiting = true
      this._save().then((result: any) => {
        this.teacherProvider.saveTeacher()
        this.waiting = false
        this.cancel()
        this.selectedActivity = null
      })
    }
  }

  _save() {
    return new Promise(async (resolve, reject) => {
      try {
      
        let songWasRemoved: boolean = false
        let removedSongUUID: string = ''
        let removedSongIndex: number = -1

        const isActivityAlreadyBooked: boolean = this.lesson.songs
          .some((e) => e.songUuid == this.song.uuid)

        // if song is already selected remove it
        if (isActivityAlreadyBooked) {
          this.lesson.songs.forEach((e, i) => {
            if (e.songUuid == this.song.uuid) {
              e.copyFrom(LessonSong.defaults())
              e.isDirty = true
              songWasRemoved = true
              removedSongUUID = this.song.uuid
              removedSongIndex = i
            }
          })
        }

        // Get updated copies of course and lesson from teacher
        const localCourse = this.teacher.findCourse(this.course.uuid)
        const localLesson = localCourse.findLesson(this.lesson.uuid)

        const lessonSong = LessonSong.createFrom(this.song)
        
        if (songWasRemoved) {

          this.teacherProvider.updateLesson(this.course, this.lesson)

        } else {

          let index: number = this.lesson.indexOfLessonSong(this.selectedActivity.uuid)
          if (index >= 0) {
            const updatedLessonSong: any = this.lesson.songs[index]
            if (updatedLessonSong) {
              updatedLessonSong.copyFrom(lessonSong)
              updatedLessonSong.isDirty = true          
            }
  
            const localIndex = localLesson.indexOfLessonSong(this.selectedActivity.uuid)

            const updatedLessonSongLocal: any = localLesson.songs[localIndex]
            updatedLessonSongLocal.copyFrom(lessonSong)
            updatedLessonSongLocal.isDirty = true                 
          }
  
          this.teacherProvider.updateLesson(localCourse, localLesson)
          

        }

        resolve(true)
      }
      catch (err) {
        reject(err);
      }
    })
  }

  isActivityDisabled(slot) {
    const slotsBooked = this.lesson.songs
      .filter((e) => e.songUuid)
      .map((e) => e.songUuid)
    if (slotsBooked.length == 0) {
      return false
    }
    if (slotsBooked.includes(slot.songUuid)) {
      return true
    }
    return false
  }

  allowSubmit(): boolean {
    return this.hasValue && !this.waiting
  }

  // isActivityAlreadyBooked(slot) {
  //   let activityIndices: any = ""
  //   this.lesson.songs.forEach((lessonSong: LessonSong, index: number) => {
  //     if (!slot.songUuid) {
  //       return activityIndices
  //     }
  //     if (lessonSong.songUuid === slot.songUuid) {
  //       activityIndices = index + 1;
  //     }
  //   })
  //   return activityIndices
  // }
}
